import { render } from "./PersonnalCard.vue?vue&type=template&id=be274564&scoped=true"
import script from "./PersonnalCard.vue?vue&type=script&lang=js"
export * from "./PersonnalCard.vue?vue&type=script&lang=js"

import "./PersonnalCard.vue?vue&type=style&index=0&id=be274564&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be274564"]])

export default __exports__